import { render } from "./Pemilu&Pilkada.vue?vue&type=template&id=48556738&scoped=true"
import script from "./Pemilu&Pilkada.vue?vue&type=script&lang=js"
export * from "./Pemilu&Pilkada.vue?vue&type=script&lang=js"

import "./Pemilu&Pilkada.vue?vue&type=style&index=0&id=48556738&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48556738"]])

export default __exports__